'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef } from 'react';
import type { DesfechoDoDownload, DownloadDespachado, IdentificaRecusa, RecusaDoDownload } from '@/shared/types/downloadEmVoo';
const IGNORADO = {
  tipo: 'ignorado'
} as const;
const CONCLUIDO = {
  tipo: 'concluido'
} as const;

/**
 * O controle do download do PDF de um certificado: no máximo um no ar, e `abortar` para o cleanup
 * de quem sai da tela, para o arquivo de quem já saiu não ir para o disco.
 *
 * `ehRecusa` é o `thunk.rejected.match` do thunk que `baixar` despacha.
 */
export function useDownloadEmVoo(ehRecusa) {
  const $ = _c(5);
  const emVooRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      emVooRef.current?.abort();
      emVooRef.current = null;
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const abortar = t0;
  let t1;
  if ($[1] !== ehRecusa) {
    t1 = async despachar => {
      if (emVooRef.current) {
        return IGNORADO;
      }
      const emVoo = despachar();
      emVooRef.current = emVoo;
      const resultado = await emVoo;
      if (emVooRef.current === emVoo) {
        emVooRef.current = null;
      }
      if (!ehRecusa(resultado)) {
        return CONCLUIDO;
      }
      if (resultado.meta.condition || resultado.meta.aborted) {
        return IGNORADO;
      }
      return {
        tipo: "falhou",
        erro: resultado.payload
      };
    };
    $[1] = ehRecusa;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const baixar = t1;
  let t2;
  if ($[3] !== baixar) {
    t2 = {
      baixar,
      abortar
    };
    $[3] = baixar;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}